export default __webpack_public_path__ + "static/media/office.aeb25f17.svg";